import React from "react";
import Confetti from "react-confetti";

const CustomConfetti = () => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 9999, // High z-index to bring it to the front
        pointerEvents: "none", // Allow interactions with underlying elements
      }}
    >
      <Confetti
        numberOfPieces={5000}
        recycle={false}
        width={window.innerWidth}  // Set width to fill screen
        height={window.innerHeight} // Set height to fill screen
      />
    </div>
  );
};

export default CustomConfetti;
